import React from 'react';
import SectionTitle from '../SectionTitle/SectionTitle';

/* image */
import Pross1 from '../../images/work/1.png'
import Pross2 from '../../images/work/2.png'
import Pross3 from '../../images/work/3.png'
import Pross4 from '../../images/work/4.png'
import Shape from '../../images/work/shape.svg'

const ProcessSection = (props) => {
    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 col-12">
                        <SectionTitle title={'Our Working Process'} subtitle={'How We Work'}/>
                    </div>
                </div>
                <div className="work_wrapper">
                    <div className="row">
                        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                            <div className="work_card">
                                <div className="image">
                                    <img src={Pross1} alt="" />
                                        <span className="number">01</span>
                                </div>
                                <div className="text">
                                    <h3>Make an Appointment</h3>
                                    <p>Our process begins by scheduling an appointment at your convenience. We ensure that every consultation is personalized, allowing us to address your specific needs effectively. Reach out to us to find a time that works best for you.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                            <div className="work_card">
                                <div className="image">
                                    <img src={Pross2} alt="" />
                                        <span className="number">02</span>
                                </div>
                                <div className="text">
                                    <h3>Consult with Experts</h3>
                                    <p>Once your appointment is set, you'll have the opportunity to consult with our experienced medical professionals. They will provide expert advice, guide you through your healthcare options, and tailor the best treatment plan based on your condition.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                            <div className="work_card">
                                <div className="image">
                                    <img src={Pross3} alt="" />
                                        <span className="number">03</span>
                                </div>
                                <div className="text">
                                    <h3>Receive Treatment</h3>
                                    <p>After your consultation, we’ll proceed with the necessary treatment plan. Our goal is to ensure your comfort and well-being while providing high-quality, advanced care in a safe environment.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                            <div className="work_card">
                                <div className="image">
                                    <img src={Pross4} alt="" />
                                        <span className="number">04</span>
                                </div>
                                <div className="text">
                                    <h3>Get Relief</h3>
                                    <p>With the right treatment in place, you’ll begin to experience relief and improvements in your condition. We’re committed to helping you feel better and supporting your journey to optimal health.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="shape">
                        <img src={Shape} alt="" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProcessSection;